// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1uXMe","alert":"SettungsInbox_alert__6y_jj"};